import { ExclamationCircleOutlined } from "@ant-design/icons"
import { Tax } from "@finway-group/shared/lib/models"
import { isBuCodeDATEVCompliant } from "@finway-group/shared/lib/utils/datevValidation"
import { Button, Alert, PageHeader, Card, Row, Col } from "antd"
import TaxModal from "Components/modals/tax.modal"
import React from "react"
import { Edit as EditIcon, Plus as PlusIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { WARNING_ORANGE } from "Shared/config/consts"
import { useModal } from "Shared/context/modal.context"
import { useTaxes } from "Shared/hooks/tax.hooks"
import { getTaxLabel } from "Shared/utils/helpers"

const TaxSettings = () => {
    const { t } = useTranslation()
    const taxValues = useTaxes(true)
    const { showModal } = useModal()
    const history = useHistory()

    const isDatevCompliant = taxValues.every((tax: Tax) => !tax.buCode || isBuCodeDATEVCompliant(tax.buCode))

    return (
        <div id="finway-expense-settings" className="w-full">
            <div className="md:hidden">
                <PageHeader
                    ghost={false}
                    onBack={() => history.push("/settings")}
                    title={<h2 className="mb-0">{t("label:vat_title")}</h2>}
                    extra={[
                        <div className="ml-10">
                            <Button onClick={() => showModal(TaxModal, false, { taxes: taxValues, isShowing: true })}>{taxValues.length > 0 ? <EditIcon /> : <PlusIcon />}</Button>
                        </div>,
                    ]}
                ></PageHeader>
            </div>

            <div className="justify-between items-center mb-10 hidden md:flex xs:items-center">
                <h2 className="mb-0">{t("label:vat_title")}</h2>
                <div className="ml-10">
                    <Button onClick={() => showModal(TaxModal, false, { taxes: taxValues, isShowing: true })}>
                        {taxValues.length > 0 ? (
                            <>
                                <EditIcon />
                                <span>{t("action:edit")}</span>
                            </>
                        ) : (
                            <>
                                <PlusIcon />
                                <span>{t("action:create")}</span>
                            </>
                        )}
                    </Button>
                </div>
            </div>
            {!isDatevCompliant && <Alert type="warning" showIcon className="mb-20" message={t("info:bu_code_datev_compliance")} />}
            {taxValues.length === 0 ? (
                <div className="text-text-dark p-10">{t("missing:no_tax")}</div>
            ) : (
                <div className="p-5 w-full h-screen md:max-h-450 overflow-y-auto overflow-x-hidden">
                    <Row gutter={[16, 16]} className="font-bold">
                        <Col flex="auto" className="text-left self-center">
                            {t("label:vat_rate")}
                        </Col>
                        <Col flex="auto" className="text-right self-center">
                            {t("label:bu_code")}
                        </Col>
                    </Row>
                    {taxValues.map((tax: Tax, index: number) => (
                        <Row gutter={[16, 16]} key={index}>
                            <Col span={16} className="text-left self-center truncate">
                                {getTaxLabel(tax)}
                            </Col>
                            <Col span={8} className="self-center truncate flex items-center justify-end">
                                {tax.buCode ? tax.buCode : "-"}
                                {tax.buCode && !isBuCodeDATEVCompliant(tax.buCode) && <ExclamationCircleOutlined className="ml-6" style={{ color: WARNING_ORANGE }} />}
                            </Col>
                        </Row>
                    ))}
                </div>
            )}
        </div>
    )
}

export default React.memo(TaxSettings)
